"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2429],{

/***/ 4203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "eulst6f0"
} : 0)( true ? {
  name: "11726p1",
  styles: "height:auto;position:relative;margin:0 auto;display:block"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.tsx


var _excluded = ["src", "alt", "width", "height", "unoptimized", "loader"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var imageLoader = function imageLoader(_ref) {
  var src = _ref.src;
  return "".concat(src);
};

var Image = function Image(_ref2) {
  var src = _ref2.src,
      alt = _ref2.alt,
      width = _ref2.width,
      height = _ref2.height,
      _ref2$unoptimized = _ref2.unoptimized,
      unoptimized = _ref2$unoptimized === void 0 ? true : _ref2$unoptimized,
      loader = _ref2.loader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, _objectSpread(_objectSpread({
    loader: loader || imageLoader,
    width: width,
    height: height,
    src: src,
    alt: alt
  }, props), {}, {
    unoptimized: loader ? false : unoptimized
  }));
};
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/index.ts


/***/ }),

/***/ 9642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16297);



var useTrustArcLink = function useTrustArcLink() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      trustArcEnabled = _useState[0],
      setTrustArcEnabled = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var wt = window;

    if (wt.truste) {
      var consent = (0,_segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)("notice_behavior");

      if (consent !== "none") {
        setTrustArcEnabled(true);
      }
    }
  }, []);
  return trustArcEnabled;
};

/* harmony default export */ __webpack_exports__["Z"] = (useTrustArcLink);

/***/ }),

/***/ 84629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AU": function() { return /* reexport */ Contents; },
  "CK": function() { return /* reexport */ Copy; },
  "l0": function() { return /* reexport */ Form; },
  "Ee": function() { return /* reexport */ Hero_views_Image; },
  "YE": function() { return /* reexport */ Sidebar; },
  "im": function() { return /* reexport */ Wrapper; },
  "ZP": function() { return /* reexport */ Hero; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Hero/Hero.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wf27jo6"
} : 0)( true ? {
  name: "1lm435r",
  styles: "max-width:1280px;width:100%;margin:0 auto"
} : 0);
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wf27jo5"
} : 0)( true ? {
  name: "co624e",
  styles: "grid-area:copy"
} : 0);
var Contents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wf27jo4"
} : 0)( true ? {
  name: "15q12n7",
  styles: "grid-area:contents;width:100%"
} : 0);
var Form = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wf27jo3"
} : 0)( true ? {
  name: "f1j2gv",
  styles: "max-width:420px;margin-top:30px"
} : 0);
var Hero_views_Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1wf27jo2"
} : 0)("max-width:100%;display:block;height:auto;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{display:", function (_ref2) {
  var hideOnMobile = _ref2.hideOnMobile;
  return hideOnMobile ? "none" : "block";
}, ";}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wf27jo1"
} : 0)("display:grid;grid-template-areas:'copy' 'contents';gap:40px;padding:40px 24px 40px;", Contents, "{justify-items:center;display:grid;}", function (_ref3) {
  var theme = _ref3.theme;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.up("sm"), "{padding:40px 40px 80px;}", theme.breakpoints.up("md"), "{padding:40px 80px 120px;}", theme.breakpoints.up("xl"), "{padding:80px 80px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, " ", function (_ref4) {
  var variant = _ref4.variant,
      copyVariant = _ref4.copyVariant;
  return variant === "centered" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("grid-template-rows:auto auto;justify-items:center;text-align:center;", Copy, "{max-width:", copyVariant === "narrow" ? "504px" : "844px", ";}", Form, "{margin-left:auto;margin-right:auto;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant;
  return variant === "2Col" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("justify-content:center;align-items:center;", theme.breakpoints.down("md"), "{text-align:center;", Form, "{margin-left:auto;margin-right:auto;}}", theme.breakpoints.up("lg"), "{gap:80px;max-width:100%;grid-template-columns:minmax(352px, 50%) minmax(480px, 50%);grid-template-areas:'copy contents';justify-content:flex-start;", Contents, "{min-width:460px;}}", theme.breakpoints.up("xl"), "{gap:80px;}", theme.breakpoints.up("xxl"), "{gap:120px;padding:80px 0;margin:0 auto;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref6) {
  var theme = _ref6.theme,
      variant = _ref6.variant;
  return variant === "sidebar" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("row-gap:40px;column-gap:56px;grid-template-areas:'contents' 'sidebar';", theme.breakpoints.up("sm"), "{row-gap:80px;}", theme.breakpoints.up("lg"), "{grid-template-areas:'sidebar contents';grid-template-columns:210px auto;row-gap:0;column-gap:80px;}", theme.breakpoints.up("xl"), "{grid-template-columns:276px auto;column-gap:160px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref7) {
  var theme = _ref7.theme,
      variant = _ref7.variant;
  return variant === "article" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("grid-template-areas:'contents';padding:40px 24px;", theme.breakpoints.up("md"), "{padding:40px;}", theme.breakpoints.up("lg"), "{padding:80px;grid-template-columns:minmax(0, 672px);}", theme.breakpoints.up("xl"), "{grid-template-columns:minmax(0, 784px);}", theme.breakpoints.up("xxl"), "{grid-template-columns:minmax(0, 844px);padding:80px 0px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var Sidebar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1wf27jo0"
} : 0)( true ? {
  name: "1ajelae",
  styles: "grid-area:sidebar;width:100%"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Hero/Hero.tsx



var Hero = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var variant = _ref.variant,
      _ref$copyVariant = _ref.copyVariant,
      copyVariant = _ref$copyVariant === void 0 ? "wide" : _ref$copyVariant,
      children = _ref.children,
      className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
    className: className,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
      ref: ref,
      variant: variant,
      copyVariant: copyVariant,
      children: children
    })
  });
});
/* harmony default export */ var Hero_Hero = ((/* unused pure expression or super */ null && (Hero)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Hero/index.tsx


Hero.displayName = "HeroBase";
Wrapper.displayName = "Hero.Wrapper";
Copy.displayName = "Hero.Copy";
Contents.displayName = "Hero.Contents";
Sidebar.displayName = "Hero.Sidebar";
Form.displayName = "Hero.Form";
Hero_views_Image.displayName = "Hero.Image";


/***/ })

}]);